import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Row, Col, Button, Card, Modal, Tab, Nav } from 'react-bootstrap'
import AForm from './aform';
import StartModal from './startcampaignmodal';
import TestAgentModal from './testagentmodal';

function Agents(props) {
    const [agents, setAgents] = useState([])
    const [selectedAgent, setSelectedAgent] = useState({})
    const [showCForm, setShowCForm] = useState(false)
    const [updatingdata, setUpdatingdata] = useState(false)
    const [showstartmodal, setShowstartmodal] = useState(false)
	const [showtestagentmodal, setShowtestagentmodal] = useState(false)
    const [jobs, setJobs] = useState([])
    const [formdata, setformdata] = useState({})
    const [modifymode, setmodifymode] = useState(false)
	const [jobsLoading, setJobsLoading] = useState(false)
    const [selectedJob, setSelectedJob] = useState(0)

    const getAgents = (uid) => {
        axios.get(`/voiceagents/${uid}`)
			.then(res => {
                setAgents(res.data)
				// props.setTemplates(res.data)
				// props.setSelectedAgent(res.data[0].id)
			})
			.catch(err => {
                console.log(err)
            })
    }


	// useEffect(() => {
	//      props.setSelectedAgent(selectedTemplate.id)
	// }, [selectedTemplate])

	// useEffect(() => {
	//     setformdata({})
	//     setShowCForm(props.showCForm)
	//     setmodifymode(false)

	// }, [props.showCForm])


	const disableCForm = () => {
        setShowCForm(false)
		setSelectedAgent({})
		getAgents(props.uid)
		setmodifymode(false)
		setformdata({})
		// props.setShowCForm(false)
		// props.setrefresh(prevdata => !prevdata)
    }

	const getjobs = () => {

		setJobsLoading(true)

        axios.post(`/getlists/${props.uid}`)
			.then(result => {
                setJobs(result.data)
                setSelectedJob(-1)
			})
			.catch(err => {
                console.log(err)
				setShowstartmodal(false)
            })
			.finally(() => setJobsLoading(false))
    }



	useEffect(() => {
        getAgents(props.uid)
    }, [showCForm, updatingdata])


    const deleteTemplate = (template) => {
        setSelectedAgent(template)
        if (window.confirm('Are you sure you want to delete this Template?')) {
            setUpdatingdata(true)
            axios.delete(`/deleteformtemplate/${template.id}`)
				.then(res => {
                    setUpdatingdata(false)
				})
                .catch(err => console.log(err))
		}
    }

    const modifyAgent = (agent) => {
        setShowCForm(true)
        setmodifymode(true)
        setSelectedAgent(agent)
        axios.get(`/voiceagent/${agent.id}`)
            .then((res) => {
                setformdata(res.data)
			})
            .catch(error => console.log(error))

    }

	return (
		<React.Fragment>
			<div className="w-100 h-100 d-flex flex-column overflow-hidden">
				<Tab.Container defaultActiveKey="voiceagents" activeKey="voiceagents">
					<Nav variant="tabs" className="fs-6 border">
						<Nav.Item>
							<Nav.Link eventKey="voiceagents">Voice Agents</Nav.Link>
						</Nav.Item>
						<Nav.Item className="ms-auto">
							<Button title="New Voice Agent" className={`btn btn-primary mx-1 float-right`} onClick={() => { setmodifymode(false); setSelectedAgent({}); setformdata({}); setShowCForm(true); }}>
								<i class={`bi bi-plus text-white`} style={{fontWeight: "bold"}}></i>
							</Button>
							<Button title="Refresh" className={`btn btn-primary mx-1 float-right`} onClick={()=>getAgents(props.uid)}>
								<i class={`bi bi-arrow-repeat`}></i>
							</Button>
						</Nav.Item>
					</Nav>
					<Tab.Content className="w-100" style={{height: "calc(100% - 34px)"}} animation={true} mountOnEnter={true} unmountOnExit={true}>
						<Tab.Pane className="w-100 h-100" eventKey="voiceagents" title="Voice Agents">
							{/* <ContactFormTemplates setrefresh={setTemplateRefresh} refresh={templateRefresh} setCampaignRefresh={setCampaignRefresh} handleTabSelection={handleTabSelection} uid={props.uid} setSelectedAgent={setSelectedAgent} setTemplates={setTemplates} isCreateTemplateVisible={isCreateTemplateVisible} showCForm={showCForm} setShowCForm={setShowCForm} /> */}
							<div className={`m-2`}  style={{maxHeight: "99%", display: 'grid', overflowX: 'hidden', overflowY: 'auto', gap: '4px', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))'}}>
								{agents.map((row, index) => (
									<Col xs={1} className='m-1' style={{width: '100%', boxSizing: 'border-box'}}>
										<Card key={index} onClick={() => setSelectedAgent(agents[index])} title={`Agent [ID-${row.id}]`} className={`text-primary ${row.id === selectedAgent.id ? `border-primary shadow-lg` : ""}`}>
											<Card.Header className={`text-white bg-primary p-0 align-items-center`}>
												<div className="d-flex flex-row">
													<div className="p-2">
														<span>{`Agent [ID-${row.id}]`}</span>
													</div>
												</div>
											</Card.Header>
											<Card.Body className="p-2 d-flex align-content-end flex-column">
												<Card.Text>
													<Row className="mx-0 border-top">
														<Col className="p-0">
															<b>Name</b>
														</Col>
													</Row>
													<Row className="mx-0">
														<Col className="ps-1">{row.agentname}</Col>
													</Row>
													<Row className="mx-0 border-top">
														<Col className="p-0">
															<b>Description</b>
														</Col>
													</Row>
													<Row className="mx-0">
														<Col className="ps-1">{row.description}</Col>
													</Row>
													<Row className="mx-0 border-top">
														<Col className="p-0">
															<b>Created By</b>
														</Col>
													</Row>
													<Row className="mx-0  border-bottom">
														<Col className="ps-1">{row.uname}</Col>
													</Row>
												</Card.Text>
												<Card.Text className={`m-0 p-0`}>
													<Row className={`w-100 m-0`}>
														<Col className="p-0 d-flex">
															<Button
																id={`btnm-${row.id}`}
																size="sm"
																// disabled={row.runningjobs === 0 ? false : true}
																variant="outline-primary"
																style={{borderRadius: "50%"}}
																className="me-1 border border-gray"
																onClick={() => {
																	modifyAgent(agents[index]);
																}}>
																<i class="bi bi-pencil-square"></i>
															</Button>
															<Button
																id={`btnc-${row.id}`}
																size="sm"
																variant="outline-primary"
																title="Start Campaign"
																style={{borderRadius: "50%"}}
																className="me-1 border border-gray"
																onClick={() => {
																	setShowstartmodal(true)
																	getjobs();
																	setSelectedAgent(agents[index]);
																}}>
																<i class="bi bi-rocket-takeoff"></i>
															</Button>
															<Button
																id={`btnc-${row.id}`}
																size="sm"
																variant="outline-primary"
																title="Test Agent"
																style={{borderRadius: "50%"}}
																className="me-1 border border-gray"
																onClick={() => {
																	setSelectedAgent(agents[index]);
																	setShowtestagentmodal(true)
																	// getjobs();
																}}>
																<i class="bi bi-telephone"></i>
															</Button>
															
															{row.indexingdocs ? (
																<div className="ms-auto d-flex align-items-center ms-1 me-1">
																	<small className=""> Indexing...</small>
																	<Button
																		size="sm"
																		variant="outline-primary"
																		title="Refresh"
																		style={{borderRadius: "50%"}}
																		className="ms-1 border border-gray"
																		onClick={(e) => { e.stopPropagation(); getAgents(props.uid); }}>
																		<i className={`bi bi-arrow-clockwise`}></i>
																	</Button>
																</div>
															) : null}

															<Button
																id={`btnd-${row.id}`}
																size="sm"
																disabled={row.runningjobs === 0 ? false : true}
																variant="outline-primary"
																title="Delete Template"
																style={{borderRadius: "50%"}}
																className={`${(!row.indexingdocs)?'ms-auto':''} border border-gray`}
																onClick={() => {
																	deleteTemplate(agents[index]);
																}}>
																<i className="bi bi-trash"></i>
															</Button>
														</Col>
													</Row>
												</Card.Text>
											</Card.Body>
										</Card>
									</Col>
								))}
							</div>
						</Tab.Pane>
					</Tab.Content>
				</Tab.Container>
			</div>

			<Modal show={showCForm} onHide={disableCForm} centered size="lg" backdrop="static">
				<Modal.Header closeButton={true}>
					<div className="fs-6">{modifymode ? "Modify Agent" : "Create Agent"}</div>
				</Modal.Header>
				<Modal.Body className="m-1 p-3">
					{showCForm && <AForm modifymode={modifymode} formdata={formdata} disableCForm={disableCForm} uid={props.uid} aid={selectedAgent.id} />}
				</Modal.Body>
			</Modal>

			<StartModal 
			    uid = {props.uid}
				// jobs = {jobs}
				// selectedJob = {selectedJob}
				// setSelectedJob = {setSelectedJob}
				// setJobsLoading = {setJobsLoading}
				showstartmodal = {showstartmodal}
				selectedAgent = {selectedAgent}
				setShowstartmodal = {setShowstartmodal}
			/>
			<TestAgentModal 
			    uid = {props.uid}
				// jobs = {jobs}
				// selectedJob = {selectedJob}
				// setSelectedJob = {setSelectedJob}
				// setJobsLoading = {setJobsLoading}
				loggedInUserName={props.loggedInUserName}
				showtestagentmodal = {showtestagentmodal}
				selectedAgent = {selectedAgent}
				setShowtestagentmodal = {setShowtestagentmodal}
			/>
		
		</React.Fragment>
	);
}

export default Agents;